import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const getInitialLanguage = () => {
  if (typeof window !== "undefined" && window.localStorage) {
    return localStorage.getItem("language") || "am";
  }
  return "am"; // default language for SSR or non-browser environments
};

i18n.use(initReactI18next).init({
  resources: {
    en: {
      translation: {
          home: "Home",
          aboutUs: "About Us",
          contactUs: "Contact Us",
          User: "User",
          profile: "Profile",
          bookingHistory: "Booking History",
          login: "Login",
          logout: "Sign out",
          "Number of documents": "Number of documents",
          welcome_to_qetero: "Welcome to Qetero",
          "Welcome_to_Documents_Authentication_and_Registration_Service_(DARS)_at_Qetero.com":
              "Welcome to Documents Authentication and Registration Service (DARS)",
          selectLocation: "Select Location",
          selectService: "Select Service",
          selectDateAndTime: "Select Date and Time",
          selectDate: "Select Date",
          AvailableTimes: "Available Times",
          Fetchingavailabletimeslots: "Fetching available time slots...",
          save_time_and_book_now: "Save Time & Book Now",
          confirm_appointment: "Confirm Appointment",
          "Only Meeting Minutes": "Only Meeting Minutes",
          service_type: "Service Type",
          scheduled_for: "Scheduled For",
          booked_by: "Booked By",
          location: "Location",
          payment_summary: "Payment Summary",
          total_appointment_fee: "Total Appointment Fee",
          pay_now: "Pay Now",
          request_cancellation: "Request Cancellation",
          dars_application_no: "DARS Application No",
          selectBranch: "Select Branch",
          selectBranchReSchedule: "Select Branch for Reschedule",
          selectTimeSlot: "Select Time Slot",
          next: "Next",
          bookAppointment: "Book Appointment",
          cancel: "Cancel",
          morning: "Morning",
          afternoon: "Afternoon",
          branchName: "Branch",
          slot: "slot",
          slots: "slots",
          branch: "Branch",
          "For 1 appointment, you can have up to 3 documents.":
              "For 1 appointment, you can have up to 3 documents.",
          service: "Service",
          date: "Date",
          time: "Time",
          select: "Select",
          selam: "Selam",
          whoWeAre: "Who We Are",
          aboutUsDescription: "Welcome to Qetero, the ultimate online booking system designed to streamline your scheduling needs. Our platform is built with efficiency, ease of use, and customer satisfaction in mind, ensuring a smooth experience for both service providers and clients.",
          missionDescription: "At Qetero, our mission is to provide a seamless and efficient online booking experience, allowing users to manage their schedules effortlessly while maximizing convenience and accessibility.",
          vision: "Our Vision",
          visionDescription: "Our vision is to become a leader in online booking solutions, recognized for our innovation, reliability, and exceptional customer service. We aim to revolutionize the way individuals and businesses schedule their appointments.",
          coreValues: "Core Values",
          coreValuesDescription: "We prioritize the needs of our customers, fostering a culture of reliability, integrity, and continuous improvement. Our commitment to excellence drives us to innovate and adapt to the evolving demands of the industry.",
          searchService: "Search Service",
          searchBranch: "Search Branch",
          darsBranches: "DARS branches",
          showMore: "Show More",
          showLess: "Show Less",
          "Megenagna (Branch 3)": "Megenagna (Branch 3)",
          "Meskel Square": "Meskel Square",
          "Bole Bulala (Branch 16)": "Bole Bulala (Branch 16)",
          "Lebu Maberat Haile (Branch 15)": "Lebu Maberat Haile (Branch 15)",
          "Jemo 1 Condominium (Branch 14)": "Jemo 1 Condominium (Branch 14)",
          "Summit Adebabay (Branch 13)": "Summit Adebabay (Branch 13)",
          "Bole Medhanialem (Branch 12)": "Bole Medhanialem (Branch 12)",
          "Qera (Branch 6)": "Qera (Branch 6)",
          "Kasanchis - Bambis (Branch 8)": "Kasanchis - Bambis (Branch 8)",
          "4 Kilo (Branch 4)": "4 Kilo (Branch 4)",
          "6 Kilo (Branch 16)": "6 Kilo (Branch 16)",
          "Global Lancha (Branch 1)": "Global Lancha (Branch 1)",
          DireDawa: "Dire Dawa",
          "Imperial | MESOB": "Imperial | MESOB",
          "Plc Services": "Plc Services",
          "Sales Services": "Sales Services",
          "Gift Services": "Gift Services",
          "Rental Services": "Rental Services",
          "Loan Services": "Loan Services",
          "Representation Services": "Representation Services",
          enjoyFreeService: "Skip the long queues and save time with Qetero! Book your appointment for free now before booking fees start soon.",
          freeForNow: "Free for now!",
          stayTuned: "Stay tuned for the next appointment.",
          processing: "Processing...",
          loading: "Loading...",
          back: "Back",
          enterPhoneNumber: "Enter your Phone Number",
          phoneNumber: "Phone Number",
          sendVerificationCode: "Send Verification Code",
          sending: "Sending...",
          verificationCodeSent: "Verification code sent successfully!",
          book_now: "Book Now",
          Closed: "Closed",
          Open: "Open",
          Closes: "Closes",
          appointmentBooked: "Appointment Booked!",
          appointmentBookedSuccessfully: "Appointment Booked Successfully",
          receipt: "Receipt",
          appointmentTime: "Appointment Time",
          scanQRCode: "Scan the QR code to access your appointment details.",
          close: "Close",
          enterOtp: "Enter OTP",
          otp: "OTP",
          verify: "Verify",
          otpVerified: "OTP verified successfully!",
          paymentSuccess: "Payment Successful!",
          paymentFailed: "Payment Failed!",
          tryAgain: "Try Again",
          appointmentCanceled: "Appointment Canceled!",
          appointmentCanceledSuccessfully: "Appointment Canceled Successfully!",
          cancelAppointment: "Cancel Appointment",
          confirm: "Confirm",
          downloadReceipt: "Download Receipt",
          download: "Download",
          // Keep adding other keys here as needed, avoid duplicates
          total: "Total",
          upcoming: "Upcoming",
          completed: "Completed",
          search: "Search",
          noBookingFound: "No bookings found",
          view: "View",
          reschedule: "Reschedule",
          status: "Status",
          searchPlaceHolder: "Search by CNR...",
          step: "Step",
          easyStepsToRegister: "How to Register and Book an Appointment",
          selectBranchFromOptions: "Select a branch from the available options.",
          enterPhonenumberAndGetOTP:
              "Enter your phone number to receive an OTP for verification.",
          verifyAndSelectService: "Once verified, choose the service you require.",
          selectDateOfAppointment: "Select the date for your appointment.",
          chooseTimeSlot: "Choose a time slot from the available options.",
          clickOnBookAppointment: "Click on 'Book Appointment' to proceed.",
          confirmAppointmentAndConfirm:
              "Confirm your appointment in the pop-up that appears by pressing 'Book Appointment'.",
          enterTelebirrPinAndComplete:
              "Enter your Telebirr PIN and verify to complete the booking.",
          termsAndConditions: "Terms and Conditions",
          help: "Help",
          agree: "Agree",
          firstName: "First Name",
          lastName: "Last Name",
          signUp: "Sign Up",
          createAnAccount: "Create an Account",
          userAgreementToTerms: "You Must Agree to Terms and conditions.",
          readTermsAndConditions: "You must at least read the terms once.",
          allFieldsAreReqired: "All Fields are required.",
          verifyPhoneNumber: "Mobile Phone Verification",
          enterOtpOfFiveDigit:
              "Enter the 5-digit verification code that was sent to +251",
          didntReceivePin: "Didn't receive code?",
          resendIn: "Resend in",
          seconds: "seconds",
          verifyAccount: "Verify Account",
          verifying: "Verifying",
          rate_your_experience:
              "Please rate your satisfaction based on your previous experience with our service:",
          leave_a_comment: "Leave a comment...",
          submit: "Submit",
          submitting: "Submitting...",
          appointment_date: "Appointment Date",
          "Please select a rating": "Please select a rating",
          "Thank you for your feedback!": "Thank you for your feedback!",
          "Your review has been submitted successfully.":
              "Your review has been submitted successfully.",
          "There was an error submitting your review. Please try again later.":
              "There was an error submitting your review. Please try again later.",
          "Review Submitted Successfully": "Review Submitted Successfully",
          "Review Submission Failed": "Review Submission Failed",
          "Something went wrong": "Something went wrong",
          "Please try again later": "Please try again later",
          "Booking for": "Booking for",
          "Booking for self": "My Self",
          "Booking for other": "Other",
          "First Name": "First Name",
          "Last Name": "Last Name",
          Mobile: "Mobile",
          "Please select booking for": "Please select booking for",
          "Please enter first name": "Please enter first name",
          "Please enter last name": "Please enter last name",
          "Please enter mobile number": "Please enter mobile number",
          "Invalid mobile number": "Invalid mobile number",
          "Please enter valid mobile number": "Please enter valid mobile number",
          "Please select a branch": "Please select a branch",
          "Please select a service": "Please select a service",
          "Please select a date": "Please select a date",
          "Please select a time slot": "Please select a time slot",
          "Please enter a valid mobile number": "Please enter a valid mobile number",
          "confirm_booking": "Confirm Booking",
          confirmAndPay: "Confirm and Pay",
          pay_with_telebirr: "Pay with Telebirr",
          pay_with_cbe: "Pay with CBE SuperApp",
          pay_with_cbe_birr: "Pay with CBE Birr Plus",
          openInCbeSuperApp: "Open in CBE SuperApp",
          openInCbeBirrPlus: "Open in CBE Birr Plus",
          "CBE SuperApp": "CBE SuperApp",
          "CBE Birr Plus": "CBE Birr Plus",
          openedIn: "Opened in",
          openedInBrowser: "Browser",
          openedInCbeApp: "CBE SuperApp",
          openedInCbeBirrPlus: "CBE Birr Plus",
          cbeBirrUnauthorized: "CBE Birr Plus session is invalid. Please reopen Qetero from CBE Birr Plus.",
          openedInMpesaApp: "M-Pesa App",
          openedInTelebirrApp: "Telebirr App",
          serviceFee: "Service Fee",
          totalFee: "Total Fee",
          resendAgain: "Resend Code",
          confirmDate: "Confirm Date?",
          selectedDate: "Selected date",
          ethiopianDate: "Ethiopian date",
          pay_service_fee: "Pay Your Service Fee ",
          amount: "Amount: ",
          pay: "Pay",
          bookingTime: "Booking Time",
          bookingDate: "Booking Date",
          "Exciting news!": "News!",
          announcement_title: "SERVICE NOTICE",
          announcement_body_main:
              "All branches will be closed on Friday afternoon, October 17, 2025, after 9:00 (local time). 3:00 pm.",
          announcement_body_followup:
              "You may reschedule your appointment for another date and time.",
          are_you_sure_you_want_to_confirm:
              "Are you sure you want to confirm your appointment at {{time}}?",
          noSubServicesAvailable: "No sub-services available",
          errorLoadingSubServices: "Error loading sub-services",
          select_organization: "Select Organization",
          appointment_for: "Booking For",
          "Addisu gebeya": "Addisu gebeya",
          "Ayat Adebabay": "Ayat Adebabay",
          "Ayer Tena": "Ayer Tena",
          "Bole": "Bole",
          "Bulbula": "Bulbula",
          "Jemo": "Jemo",
          "Kality": "Kality",
          "Kasanchis": "Kasanchis",
          "Lancha": "Lancha",
          "Lafto": "Lafto",
          "Ledeta": "Ledeta",
          "Megenagna": "Megenagna",
          "Qera": "Qera",
          "Sidist Kilo": "Sidist Kilo",
          "Summit": "Summit",
          "VIP-Megenagna": "VIP-Megenagna",
          Map: "Map",
          min: "min",
          "Selected Branch": "Selected Branch",
          "Representation related service": "Representation related service",
          "Rental related service": "Rental related service",
          "Sales related service": "Sales related service",
          "PLC related service": "PLC related service",
          "Gift related service": "Gift related service",
          "Loan related service": "Loan related service",
          "Other related service": "Other related service",
          "Document authentication related service": "Document authentication related service",
          "Document Authentication": "Document Authentication",
          "Representation": "Representation",
          "Rental": "Rental",
          "Sales": "Sales",
          "PLC": "PLC",
          "Gift": "Gift",
          "Loan": "Loan",
          "Other": "Other",
          "No slot available": "No slot available",
          "Please check another time or date": "Please check another time or date",
          "Failed to load slots": "Failed to load slots",
          "Something went wrong while fetching available times. Please try again.": "Something went wrong while fetching available times. Please try again.",
          "continue": "Continue",
          priceSummary: "Price Summary",
          totalServiceCharge: "Total Service Charge",
          numberOfDocuments: "Number of Documents",
          documents: "Documents",
          document: "Document",
          all: "All",
          VerifyYourNumber: "Verify Your Number",
          "We'll send a verification code to your phone.": "We'll send a verification code to your phone.",
          MobileNumber: "Mobile Number",
          "Enter without country code (e.g., 911223344)": "Enter without country code (e.g., 911223344)",
          "By continuing, you agree to our": "By continuing, you agree to our",
          "Terms of Service": "Terms of Service",
          "Privacy Policy": "Privacy Policy",
          and: "and",
          "Please enter a valid phone number": "Please enter a valid phone number",
          "Enter the verification code sent.": "Enter the verification code sent.",
          "Verification code sent to a phone number": "Verification code sent to a phone number",
          "Login successful": "Login successful",
          "Account not found. Please create an account.": "Account not found. Please create an account.",
          bookingSummary: "Booking Summary",
          "moreThanTwoDocumentsWarning": "If you have more than 2 documents, please book another appointment.",
          "moreThanThreeDocumentsWarning": "If you have more than 3 documents, please book another appointment.",

          expired: "Expired",
          Monday: "Monday",
          Tuesday: "Tuesday",
          Wednesday: "Wednesday",
          Thursday: "Thursday",
          Friday: "Friday",
          Saturday: "Saturday",
          Sunday: "Sunday",
          "Please fill all fields": "Please fill all fields",
          "Account created successfully": "Account created successfully",
          "Failed to create account. Please try again.": "Failed to create account. Please try again.",
          "OTP sent successfully": "OTP sent successfully",
          "Failed to send OTP": "Failed to send OTP",
          "Payment initiation failed": "Payment initiation failed",
          "Failed to create appointment": "Failed to create appointment",
          "Error creating appointment:": "Error creating appointment:",
          "Please select date and time to continue": "Please select date and time to continue",
          "Please select a payment method": "Please select a payment method",
          "Please select number of documents": "Please select number of documents",
          "Provide your name to continue.": "Provide your name to continue.",
          "I agree to the": "I agree to the",
          register: "Register",
          "Creating Account...": "Creating Account...",
          "Appointments are non-refundable.": "Appointments are non-refundable.",
          "Appointments cannot be transferred to another person.": "Appointments cannot be transferred to another person.",
          "The appointment is valid only for the specific service you have booked.": "The appointment is valid only for the specific service you have booked.",
          "You may only book Three service per appointment.": "You may only book Three service per appointment.",
          "A valid ID must be presented at the time of the appointment.": "A valid ID must be presented at the time of the appointment.",
          "You must arrive on time for your appointment.": "You must arrive on time for your appointment.",
          "If you are late, we reserve the right not to serve you.": "If you are late, we reserve the right not to serve you.",
          "Appointment Policy Consent": "Appointment Policy Consent",
          "Member since": "Member since",
          Active: "Active",
          Inactive: "Inactive",
          "Select Payment Method": "Select Payment Method",
          "How Register and Book an Appointment": "How to Register and Book an Appointment",
          "1. Select whom you are booking for.": "1. Select whom you are booking for.",
          "2. Select a specific branch you want to go. you have an option to search or filter the branches": "2. Select a specific branch you want to go. you have an option to search or filter the branches",
          "3. Enter your phone number and verify using the OTP you receive on your phone number.": "3. Enter your phone number and verify using the OTP you receive on your phone number.",
          "4. Once verified, choose the service you require.": "4. Once verified, choose the service you require.",
          "5. Select the date and time for your appointment.": "5. Select the date and time for your appointment.",
          "6. Confirm you appointment and and pay using Telebirr using the popup appears on your phone": "6. Confirm you appointment and and pay using Telebirr using the popup appears on your phone",
          "7. Enter your Telebirr PIN and verify to complete the booking.": "7. Enter your Telebirr PIN and verify to complete the booking.",
          "Mobile number required": "Mobile number required",
          "OTP resent successfully": "OTP resent successfully",
          "Failed to resend OTP": "Failed to resend OTP",
          "You cannot use your own phone number for the 'Other' booking": "You cannot use your own phone number for the 'Other' booking",
          "Booking for Someone Else": "Booking for Someone Else",
          "Please enter the details of the person who will be attending the appointment.": "Please enter the details of the person who will be attending the appointment.",
          "Verify Guest's Number": "Verify Guest's Number",
          "We've sent a verification code to": "We've sent a verification code to",
          "Resending...": "Resending...",
          "Resend Code": "Resend Code",
          "qrCodeInstruction": "የQR ኮዱን ተጠቅመው ቀጠሮዎን ያስተዳድሩ እና ዝርዝሮችን ያግኙ።",
          "failedToLoadBookings": "ቀጠሮዎችን መጫን አልተቻለም",
          "errorFetchingData": "መረጃዎን በማምጣት ላይ እያለ ችግር ተፈጥሯል።",
          "noAppointmentsYet": "እስካሁን ምንም ቀጠሮ አልያዙም።",
          "noAppointmentsFoundForTab": "No {{tab}} appointments found.",
          "locations": "Locations",
          "No branches found": "No branches found",
          "We couldn't find any branches matching": "We couldn't find any branches matching",
          "Clear Search": "Clear Search",
          "downloadPdf": "Download PDF",
          "failedToLoadBranches": "Failed to load branches",
          "errorFetchingLocations": "Something went wrong while fetching the locations. Please check your connection and try again.",
          "retry": "Retry",
          "noBranchesAvailable": "We couldn't find any available branches at the moment.",
          "failedToLoadServices": "Failed to load services",
          "noServicesAvailable": "No services available",
          "errorFetchingServices": "Something went wrong while fetching services. Please try again.",
          "noServicesListed": "This branch doesn't have any services listed at the moment.",
          "reviewTerms": "Please review our terms before proceeding.",
          "iUnderstand": "I Understand",
          "Only Ethio Telecom numbers are supported": "Only Ethio Telecom numbers are supported",
          "Select Organization": "Select Organization",
          "Choose the type of facility you want to book an appointment with.": "Choose the type of facility you want to book an appointment with.",
          "Coming soon!": "Coming soon!",
          "Road Authority": "Road Authority",
          "DireDawa Court": "DireDawa Court",
          "Ministry of Urban & Infrastructure": "Ministry of Urban & Infrastructure",
          "Documents Authentication": "Documents Authentication",
          "Documents Authentication And Registration Related Facilities": "Documents Authentication And Registration Related Facilities",


          "failedToLoadOrganizations": "Failed to load organizations",
          "errorFetchingOrganizations": "Error fetching organizations",

          "Shaggar City": "Shaggar",
          "Addis Ababa": "Addis Ababa",
          "Ethiopian Electric Utility": "Ethiopian Electric Utility",
          "Harari": "Harari",
          "Dire Dawa": "Dire Dawa",
          "Transport & Logistics": "Transport and Logistics",
          "Sheger City Related Facilities": "Sheger City Related Facilities",
          "Addis Ababa City Related Facilities": "Addis Ababa City Related Facilities",
          "Harari City Related Facilities": "Harari City Related Facilities",
          "Dire Dawa City Related Facilities": "Dire Dawa City Related Facilities",
          "Transport & Logistics Related Facilities": "Transport and Logistics Related Facilities",
          "Addisu gebeya around semen hotel darule tower second floor": "Addisu gebeya around Semen Hotel Darule Tower Second Floor",
          "Lomiyad Supermarket": "Lomiyad Supermarket",
          "Around Ayer Tena Zewditu Building": "Around Ayer Tena Zewditu Building",
          "Near Mafi City Center, Dr Beyen Building 3rd floor": "Near Mafi City Center, Dr Beyen Building 3rd floor",
          "Bulbula 93, mazoria, Addis way building, 1st floor": "Bulbula 93, Mazoria, Addis Way Building, 1st Floor",
          "Jemo 1 Condominium": "Jemo 1 Condominium",
          "In Front of Kality Prison, Sheger Building 1nd floor Branch": "In Front of Kality Prison, Sheger Building 1st floor Branch",
          "Kazanchis In Front of Yordanos Hotel, Enat Building, 3rd Floor": "Kazanchis In Front of Yordanos Hotel, Enat Building, 3rd Floor",
          "Debre Zeit Road Near Agona Cinema, Balkar Building": "Debre Zeit Road Near Agona Cinema, Balkar Building",
          "Around Lafto View Gesem Building 3rd Floor": "Around Lafto View Gesem Building 3rd Floor",
          "Near Mexico Square In front of Philips Building, “Chelelek Aslam Tower” 2nd Floor": "Near Mexico Square In front of Philips Building, “Chelelek Aslam Tower” 2nd Floor",
          "Megenagna Derartu tulu Building": "Megenagna Derartu tulu Building",
          "Qera near to sante clinic, HD building 2nd floor": "Qera near to sante clinic, HD building 2nd floor",
          "Branch four sidist kilo around Egypt embassy international leadership institute 2nd floor": "Branch four sidist kilo around Egypt embassy international leadership institute 2nd floor",
          "Summit Safari, just before the traffic light, next to the British School building": "Summit Safari, just before the traffic light, next to the British School building",
          "Temneja Yaz, Global Hotel, First Hotel Branch" : "Temneja Yaz, Global Hotel, First Hotel Branch",
          "In front of Saba Building Delina Mall 3rd Floor" : "In front of Saba Building Delina Mall 3rd Floor",
          "Ayat Square – the building where Lomiad Supermarket is located, 3rd floor.”": "Ayat Square – the building where Lomiad Supermarket is located, 3rd floor.",

          "Megenagna VIP": "Megenagna VIP",
          "All Plc Service Provided": "All Plc Service Provided",
          "maxRescheduleLimitReached": "Maximum reschedule limit reached (3 times).",
          "rescheduleSuccessful": "Reschedule Successful",
          "reschedulingSummary": "Rescheduling Summary",
          "free": "Free",
          "confirmReschedule": "Confirm Reschedule",
          "rescheduleAppointment": "Reschedule Appointment",
          "Mon": "Mon",
          "Tue": "Tue",
          "Wed": "Wed",
          "Thu": "Thu",
          "Fri": "Fri",
          "Sat": "Sat",
          "Sun": "Sun",
          Available: "Available",
          "Coming Soon": "Coming Soon",
          "Except Partnership Association, All Plc Service Provided": "Except Partnership Association, All Plc Service Provided",
          "Telebirr" : "Telebirr",
          "Telebirr-Qetero" : "Telebirr-Qetero",
          "Exit" : "Exit",
          "Please review our terms before proceeding.": "Please review our terms before proceeding.",
          "I Understand" : "I Understand",
           Numberofcases: "Number of cases",
           "Translation" : "Translation",
           "whoIsAppointmentfor" : "Who is the appointment for?",
           "pleaseSelectBookingFor" : "Please select booking for",
           "bookForMyselfDesc" : "Appointment for yourself.",
           "bookForOtherDesc" : "Appointment for someone else.",
           "selectNumberOfDocuments" : "Select Number of Documents",
           "appointmentCreatedRedirecting" : "Appointment created. Redirecting to payment...",
           "nameValidationFailed": "The provided name does not match the registered user for this phone number."
           

      },
  },
  am: {
    translation: {

        home: "ዋና ገጽ",
        aboutUs: "ስለ እኛ",
        contactUs: "እኛን ያግኙ",
        profile: "መገለጫ",
        bookingHistory: "የቀጠሮ ታሪክ",
        login: "ግባ",
        logout: "ውጣ",
        help: "እርዳታ",
        welcome_to_qetero: "እንኳን ወደ ቀጠሮ በደህና መጡ",
        selectLocation: "ቦታ ይምረጡ",
        selectService: "አገልግሎት ይምረጡ",
        selectDateAndTime: "ቀን እና ሰዓት ይምረጡ",
        AvailableTimes: 'ያልተያዙ ሰዓቶች',
        Fetchingavailabletimeslots: "ያልተያዙ ቦታዎችና ሰዓቶች እየፈለገ ነው...",
        save_time_and_book_now: "ጊዜዎን ይቆጥቡ እና አሁን ይያዙ",
        termsAndConditions: "ውሎች እና ሁኔታዎች",
        failedToLoadBranches: "ቅርንጫፎችን መፈለግ አልተቻለም",
        errorFetchingLocations: "ቦታዎችን በማምጣት ላይ እያለ ችግር ተፈጥሯል። እባክዎ ግንኙነትዎን ያረጋግጡ እና እንደገና ይሞክሩ።",
        retry: "እንደገና ይሞክሩ",
        noBranchesAvailable: "በመረጡት ሰዓት ምንም ቅርንጫፍ ማግኘት አልተቻለም።",
        failedToLoadServices: "አገልግሎቶችን መጫን አልተቻለም",
        noServicesAvailable: "ምንም አገልግሎቶች የሉም",
        errorFetchingServices: "አገልግሎቶችን በማምጣት ላይ እያለ ችግር ተፈጥሯል። እባክዎ እንደገና ይሞክሩ።",
        noServicesListed: "ይህ ቅርንጫፍ በአሁኑ ጊዜ ምንም የተዘረዘሩ አገልግሎቶች የሉትም።",
        reviewTerms: "እባክዎ ከመቀጠልዎ በፊት ውሎቻችንን ይገምግሙ።",
        iUnderstand: "ተረድቻለሁ",
        confirm_appointment: "ቀጠሮዎን ያረጋግጡ",
        service_type: "የአገልግሎት አይነት",
        scheduled_for: "ለተያዘው",
        booked_by: "የተያዘው በ",
        location: "አድራሻ",
        payment_summary: "የክፍያ ማጠቃለያ",
        total_appointment_fee: "የአጠቃላይ ቀጠሮ ክፍያ",
        pay_now: "አሁን ይክፈሉ",
        request_cancellation: "የመሰረዝ ጥያቄ ያቅርቡ",
        dars_application_no: "የየሰነድ ማረጋገጫ ምዝገባ አገልግሎት ማመልከቻ ቁጥር",
        selectBranch: "ቅርንጫፍ ይምረጡ ",
        selectBranchReSchedule: "ቀጠሮ ለመቀየር ቅርንጫፍ ይምረጡ",
        selectTimeSlot: "የጊዜ ክፍተት ይምረጡ",
        specialText: "ከ ድርጅት ቃለ ጉባኤ በስተቀር ሁሉም ይሰጣል",
        specialTextTwo: "ሁሉም የድርጅት አገልግሎት ይሰጣል",
        specialTextThree: "ቃለ ጉባኤ ብቻ",
        next: "ቀጣይ",
        bookAppointment: "ቀጠሮ ይያዙ",
        cancel: "ሰርዝ",
        morning: "ጠዋት",
        afternoon: "ከሰዓት",
        slot: "ቦታ",
        slots: "ቦታዎች",
        branch: "ቅርንጫፍ",
        service: "አገልግሎት",
        date: "ቀን",
        time: "ሰዓት",
        select: "ይምረጡ",
        selectDate: "ቀን ይምረጡ",
        searchService: "አገልግሎት ይፈልጉ",
        searchBranch: "ቅርንጫፍ ይፈልጉ",
        darsBranches: " የሰነድ ማረጋገጫ ምዝገባ አገልግሎት ቅርንጫፎች",
        showMore: "ተጨማሪ አሳይ",
        showLess: "ያነሰ አሳይ",
        selam: "ሰላም",
        "Welcome_to_Documents_Authentication_and_Registration_Service_(DARS)_at_Qetero.com":
            "እንኳን ወደ የሰነዶች ማረጋገጫ እና ምዝገባ አገልግሎት (DARS)በደህና መጡ",
        "Megenagna (Branch 3)": "መገናኛ (ቅርንጫፍ 3)",
        MeskelSquare: "መስቀል አደባባይ",
        "Bole Bulala (Branch 16)": "ቦሌ ቡልቡላ (ቅርንጫፍ 16)",
        freeForNow: "አሁን ነፃ!",
        enjoyFreeService: "ረጅም መስመሮችን ይዝለሉ እና በቀጠሮ ጊዜዎን ይቆጥቡ! በቅርቡ የመያዣ ክፍያ ከመጀመሩ በፊት አሁን ነፃ ቀጠሮዎን ይያዙ።",
        stayTuned: "ለቀጣዩ ቀጠሮ ይጠብቁ።",
        processing: "በሂደት ላይ...",
        loading: "እየተከናወነ ነው...",
        back: "ወደ ኋላ",
        enterPhoneNumber: "የስልክ ቁጥርዎን ያስገቡ",
        phoneNumber: "የስልክ ቁጥር",
        sendVerificationCode: "የማረጋገጫ ኮድ ይላኩ",
        sending: "እየተላከ ነው...",
        verificationCodeSent: "የማረጋገጫ ኮድ ተልኳል!",
        book_now: "አሁን ይያዙ",
        appointmentBooked: "ቀጠሮ ተይዟል!",
        appointmentBookedSuccessfully: "ቀጠሮ በተሳካ ሁኔታ ተይዟል",
        receipt: "ደረሰኝ",
        appointmentTime: "የቀጠሮ ሰዓት",
        branchName: "ቅርንጫፍ",
        scanQRCode: "QR ኮድ ስካን ያድርጉ",
        close: "ዝጋ",
        enterOtp: "OTP ያስገቡ",
        otp: "OTP",
        verify: "ያረጋግጡ",
        otpVerified: "OTP በተሳካ ሁኔታ ተረጋግጧል!",
        paymentSuccess: "ክፍያ በተሳካ ሁኔታ ተከፍልዋል!",
        paymentFailed: "ክፍያ አልተሳካም!",
        tryAgain: "እንደገና ይሞክሩ",

        appointmentCanceled: "ቀጠሮ ተሰርዟል!",
        appointmentCanceledSuccessfully: "ቀጠሮ በተሳካ ሁኔታ ተሰርዟል!",
        cancelAppointment: "ቀጠሮ ይሰርዙ",
        confirm: "አረጋግጥ",
        downloadReceipt: "ደረሰኝ ያውርዱ",
        download: "ያውርዱ",
        Numberofcases: "ጉዳዮች ብዛት",
        "Only Meeting Minutes": "ቃለ ጉባኤ ብቻ",
        Mexico: "ሜክሲኮ",
        total: "አጠቃላይ",
        upcoming: "እየተቃረበ ያለ",
        dars:"የሰነዶች ማረጋገጫ እና ምዝገባ",
        completed: "የተጠናቀቀ",
        search: "ፈልግ",
        noBookingFound: "ምንም የተያዘ ቀጠሮ የለም።",
        view: "ዝርዝር ይመልከቱ",
        reschedule: "ቀጠሮ ይቀይሩ",
        status: "ያለበት ሁኔታ",
        searchPlaceHolder: "ቂልፍ ቃል ያስገቡ...",
        step: "እርምጃ",
        select_organization: "ድርጅት ይምረጡ",
        appointment_for: "ለማን ነው?",
        "Booking for self": "ለኔ",
        "Booking for other": "ለሌላ ሰው",
        "Addisu gebeya": "አዲሱ ገበያ",
        "Ayat Adebabay": "አያት አደባባይ",
        "Ayer Tena": "አየር ጤና",
        "Bole": "ቦሌ",
        "Bulbula": "ቡልቡላ",
        "Jemo": "ጀሞ",
        "Kality": "ቃሊቲ",
        "Kasanchis": "ካሳንቺስ",
        "Lancha": "ላንቻ",
        "Lafto": "ላፍቶ",
        "Ledeta": "ልደታ",
        "Megenagna": "መገናኛ",
        "Qera": "ቄራ",
        "Sidist Kilo": "ስድስት ኪሎ",
        "Summit": "ሰሚት",
        "VIP-Megenagna": "VIP-መገናኛ",
        "Map": "ካርታ",
        "Open": "ክፍት",
        "Closes": "ዝግ",
        "min": "ደቂቃ",
        "Selected Branch": "የተመረጠ ቅርንጫፍ",
        "Representation related service": "የተወካይነት ተያያዥ አገልግሎት",
        "Rental related service": "የኪራይ ተያያዥ አገልግሎት",
        "Sales related service": "የሽያጭ ተያያዥ አገልግሎት",
        "PLC related service": "የድርጅት ተያያዥ አገልግሎት",
        "Gift related service": "የስጦታ ተያያዥ አገልግሎት",
        "Loan related service": "የብድር ተያያዥ አገልግሎት",
        "Other related service": "ሌላ ተያያዥ አገልግሎትድርጅት",
        "Document authentication related service": "የሰነድ ማረጋገጫ ተያያዥ አገልግሎት",
        "Representation": "ውክልና",
        "Rental": "ኪራይ",
        "Sales": "ሽያጭ",
        "PLC": "ድርጅት",
        "Gift": "ስጦታ",
        "Loan": "ብድር",
        "Other": "ሌላ",
        "Document Authentication": "የሰነድ ማረጋገጫ",
        "No slot available": "ምንም ቦታ የለም",
        serviceFee: "የአገልግሎት ክፍያ",
        totalFee: "አጠቃላይ ክፍያ",
        ETB: "ብር",
        documents: "ሰነዶች",
        document: "ሰነድ",
        bookingDate: "የቀጠሮ ቀን",
        bookingTime: "የቀጠሮ ሰዓት",
        confirmAndPay: "አረጋግጥ እና ክፈል",
        pay_with_cbe: "በ CBE SuperApp ይክፈሉ",
        pay_with_cbe_birr: "በ CBE Birr Plus ይክፈሉ",
        openInCbeSuperApp: "በ CBE SuperApp ይክፈቱ",
        openInCbeBirrPlus: "በ CBE Birr Plus ይክፈቱ",
        "CBE SuperApp": "CBE SuperApp",
        "CBE Birr Plus": "CBE Birr Plus",
        openedIn: "ተከፍቷል በ",
        openedInBrowser: "አሳሽ (Browser)",
        openedInCbeApp: "CBE SuperApp",
        openedInCbeBirrPlus: "CBE Birr Plus",
        cbeBirrUnauthorized: "የ CBE Birr Plus ክፍለ ጊዜ ልክ አይደለም። እባክዎ Qeteroን ከ CBE Birr Plus እንደገና ይክፈቱ።",
        openedInMpesaApp: "M-Pesa መተግበሪያ",
        openedInTelebirrApp: "ቴሌብር መተግበሪያ",
        all: "ሁሉም",
        VerifyYourNumber: "የእርስዎን ቁጥር ያረጋግጡ",
        "We'll send a verification code to your phone.": "ለስልክዎ የማረጋገጫ ኮድ እንልክላችኋለን።",
        MobileNumber: "የሞባይል ቁጥር",
        "Enter without country code (e.g., 911223344)": "ያለ የሀገር ኮድ ያስገቡ (ለምሳሌ፣ 911223344)",
        "By continuing, you agree to our": "ቀጥል በማድረግ ወደ ዚህ እንደምትሂዱ ይረዳል",
        "Terms of Service": "የአገልግሎት ደንብ",
        "Privacy Policy": "የግለሰቦች ደንብ",
        and: "እና",
        "Please enter a valid phone number": "እባክዎ ትክክለኛ የስልክ ቁጥር ያስገቡ",
        verifying: "በመረጋግጥ ላይ...",
        "firstName": "ስም",
        "lastName": "የአባት ስም",
        "fullName": "ሙሉ ስም",
        "Enter the verification code sent.": "የተላከውን የማረጋገጫ ኮድ ያስገቡ",
        "Verification code sent to a phone number": "የማረጋገጫ ኮድ ወደ ስልክ ቁጥር ተልኳል",
        "Login successful": "በተሳካ ኔታ ገብተዋል",
        "Account not found. Please create an account.": "አካውንቶን ማኘት አልተቻለም። እባክዎ ሌላ አካውንት ይክፈቱ።",
        "Invalid OTP. Please try again.": "ማረጋገጫ ኮድ የተሳሳተ ነው። እባክዎ ደግሞ ይሞክሩ።",
        "Please enter a valid 5-digit OTP": "እባክዎ ትክክለኛ 5-ዲጂት ኮድ ያስገቡ",
        "Failed to verify OTP": "ማረጋገጫ ኮድ ማረጋገጥ ወይም የተሳሳተ ነው።",
        // Add/merge more keys as needed, avoid duplicates
        expired: "ያለፈ",
        Monday: "ሰኞ",
        Tuesday: "ማክሰኞ",
        Wednesday: "እሮብ",


        Thursday: "ሐሙስ",
        Friday: "አርብ",
        Saturday: "ቅዳሜ",
        Sunday: "እሁድ",
        "Please fill all fields": "እባክዎ ሁሉንም ቦታዎች ይሙሉ",
        "Account created successfully": "አካውንት በተሳካ ሁኔታ ተፈጥሯል",
        "Failed to create account. Please try again.": "መለያ ማፍጠር አልተሳካም። እባክዎ ደግሞ ይሞክሩ።",
        "OTP sent successfully": "OTP በተሳካ ሁኔታ ተልኳል",
        "Failed to send OTP": "OTP መላክ አልተሳካም",
        "Payment initiation failed": "የክፍያ መጀመሪያ አልተሳካም",
        "Failed to create appointment": "ቀጠሮ መቅጠር አልተሳካም",
        "Error creating appointment:": "ቀጠሮ መቅጠር ላይ ችግር አለ:",
        "Please select date and time to continue": "እባክዎ ወደ ቀጣይ ለመሄድ ቀንና ሰዓት ይምረጡ",
        "Please select a payment method": "እባክዎ የክፍያ ዘዴ ይምረጡ",
        "Please select number of documents": "እባክዎ የሰነዶች ብዛት ይምረጡ",
        "Provide your name to continue.": "እባክዎ ለመቀጠል ስምዎን ያስገቡ.",
        "I agree to the": "እስማማለሁ",
        createAnAccount: "መለያ ይፍጠሩ",
        register: "ይመዝገቡ",
        "Creating Account...": "መለያ እየፈጠረ ነው...",
        "Appointments are non-refundable.": "ለቀጠሮ የተከፈለ ክፍያ አይመለስም።",
        "Appointments cannot be transferred to another person.": "ቀጠሮ ለሌላ ሰው ማስተላለፍ አይቻልም።",
        "The appointment is valid only for the specific service you have booked.": "ቀጠሮዎ ለእርስዎ የተያዘው ለልዩ አገልግሎት ብቻ ነው።",
        "You may only book Three service per appointment.": "በአንድ ቀጠሮ እስከ ሶስት አገልግሎት ማግኘት ይችላሉ።",
        "A valid ID must be presented at the time of the appointment.": "በቀጠሮዎ ጊዜ ትክክለኛ መታወቂያ መቀረብ አለብዎታል።",
        "You must arrive on time for your appointment.": "ለቀጠሮዎ በጊዜው መድረስ ይኖርቦታል።",
        "If you are late, we reserve the right not to serve you.": "ከጊዜው ቢዘገዩ በያዙት ቀጠሮ መስተናገድ አይችሉም።",
        "Appointment Policy Consent": "የቀጠሮ ፖሊሲ ስምምነት",
        "Member since": "ከዚህ ጀምሮ አባል",
        Active: "ከፈተዋል",
        Inactive: "ያልከፈተ",
        "Select Payment Method": "የክፍያ ዘዴ ይምረጡ",
        "tele birr": "ቴሌ ብር",
        "How Register and Book an Appointment": "እንዴት መመዝገብ እና ቀጠሮ ማያዝ እንደሚቻል",
        "1. Select whom you are booking for.": "1. ለማን እንደሚያዝ ይምረጡ",
        "2. Select a specific branch you want to go. you have an option to search or filter the branches": "2. እባኮን የሚሄዱበትን ቅርንጫፍ ይምርጡ። ቅርንጫፎቹን ለመፈለግ ወይም ለመምረጥ አማራጮቹን ይጠቀሙ",
        "3. Enter your phone number and verify using the OTP you receive on your phone number.": "3. ስልክ ቁጥርዎን ያስገቡ እና በስልክዎ ላይ የሚላከውን OTP በመጠቀም ያረጋግጡ",
        "4. Once verified, choose the service you require.": "4. ካረጋገጡ በኋላ የሚፈልጉትን አገልግሎት ይምረጡ",
        "5. Select the date and time for your appointment.": "5. ለቀጠሮዎ ቀን እና ሰዓት ይምረጡ",
        "6. Confirm you appointment and and pay using Telebirr using the popup appears on your phone": "6. ቀጠሮዎን ያረጋግጡ እና ስልክዎ ላይ ባለው መመርያ መሰረት በቴሌበር ይክፈሉ",
        "7. Enter your Telebirr PIN and verify to complete the booking.": "7. የቴሌ ብር ሚስጥር ቁጥሮን ያስገቡ እና ክፍያዎን በመክፈል ቀጠሮዎ መያዙን ያረጋግጡ.",
        "Mobile number required": "የሞባይል ቁጥር ያስፈልጋል",
        "OTP resent successfully": "OTP በተሳካ ሁኔታ እንደገና ተልኳል",
        "Failed to resend OTP": "OTP እንደገና መላክ አልተሳካም",
        "You cannot use your own phone number for the 'Other' booking": "ለሌላ ሰው' ቀጠሮ የራስዎን ስልክ ቁጥር መጠቀም አይቻልም",
        "Booking for Someone Else": "ለሌላ ሰው ቀጠሮ መያዝ",
        "Please enter the details of the person who will be attending the appointment.": "እባክዎ ቀጠሮ የተያዘለትን ሰው ማንነት በትክክል ይሙሉ።",
        "Verify Guest's Number": "የእንግዳውን ቁጥር ያረጋግጡ",
        "We've sent a verification code to": "የማረጋገጫ ኮድ ወደዚህ ልከናል",
        "Resending...": "እንደገና በመላክ ላይ...",
        "Resend Code": "ኮድ እንደገና ላክ",
        "Booking for": "",
        "User": "ተጠቃሚ",
        "failedToLoadBookings": "ቀጠሮዎችን መጫን አልተቻለም",
        "errorFetchingData": "መረጃዎን በማምጣት ላይ እያለ ችግር ተፈጥሯል።",
        "failedToLoadOrganizations": "ድርጅቶችን ማግኘት አልተቻለም",


        "errorFetchingOrganizations": "የድርጅቶችን መረጃ ማምጣት ላይ ችግር ተፈጥሯል።",
        "noAppointmentsYet": "እስካሁን ምንም ቀጠሮ አልያዙም።",
        "noAppointmentsFoundForTab": "ምንም ቀጠሮዎች አልተገኙም።",
        "locations": "ቦታዎች",
        "No branches found": "ምንም ቅርንጫፎች አልተገኙም",
        "We couldn't find any branches matching": "ምንም የሚዛመዱ ቅርንጫፎች አላገኘንም",
        "Clear Search": "ፍለጋውን አጽዳ",
        "downloadPdf": "Pdf ያውርዱ",
        "Only Ethio Telecom numbers are supported": "በኢትዮ ቴሌኮም ቁጥሮች ብቻ ነው የሚሰራው ",
        "Select Organization": "ድርጅት ይምረጡ",
        "Choose the type of facility you want to book an appointment with.": "ለምን አገልግሎት ቀጠሮእንደሚይዙ ይምረጡ እና ይቅጠሩ።",
        "Coming soon!": "በቅርቡ!",
        "Road Authority": "የመንገዶች ባለሥልጣን",
        "DireDawa Court": "የድሬዳዋ ፍርድ ቤት",
        "Ministry of Urban & Infrastructure": "የከተማ እና መሰረተ ልማት ሚኒስቴር",
        "Documents Authentication": "የሰነዶች ማረጋገጫ",
        "Documents Authentication And Registration Related Facilities": "የሰነዶች ማረጋገጫ እና ምዝገባ ተያያዥ ተቋማት",
        "Shaggar City": "ሸገር",
        "Sheger City": "ሸገር",
        "Addis Ababa": "አዲስ አበባ",
        "Harari": "ሐረሪ",
        "Dire Dawa": "ድሬዳዋ",
        "Ethiopian Electric Utility": "የኢትዮጵያ ኤሌክትሪክ አገልግሎት",
        "DARS":"ሰነዶች ማረጋገጫ እና ምዝገባ",
        "Transport & Logistics": "ትራንስፖርት እና ሎጂስቲክስ",
        "Sheger City Related Facilities": "የሸገር ከተማ ተያያዥ ተቋማት",
        "Addis Ababa City Related Facilities": "የአዲስ አበባ ከተማ ተያያዥ ተቋማት",
        "Harari City Related Facilities": "የሐረሪ ከተማ ተያያዥ ተቋማት",
        "Dire Dawa City Related Facilities": "የድሬዳዋ ከተማ ተያያዥ ተቋማት",
        "Transport & Logistics Related Facilities": "የትራንስፖርት እና ሎጂስቲክስ ተያያዥ ተቋማት",
        "Addisu gebeya around semen hotel darule tower second floor": "አዲሱ ገበያ ሰሜን ሆቴል መብራቱ ከፍ ብሎ ዳሩሌ ታወር 2ኛ ፎቅ",
        "Lomiyad Supermarket": "አያት አደባባይሎሚያድ ሱፐርማርኬት ያለበት ህን 2ኛ ፎቅ",
        "Around Ayer Tena Zewditu Building": "አየር ጠና ዘውዲቱ ሕንጻ 3ኛ ፎቅ",
        "Near Mafi City Center, Dr Beyen Building 3rd floor": "ማፊ ሲቲ ሴንተር አጠገብ፣ ዶክተር በያን ሕንጻ 3ኛ ፎቅ",
        "Bulbula 93, mazoria, Addis way building, 1st floor": "ቡልቡላ 93፣ ማዞሪያ፣ አዲስ መንገድ ሕንጻ፣ 1ኛ ፎቅ",
        "Jemo 1 Condominium": " ጀሞ 1 ኮንዶሚኒየም አካባቢሳባ ሕንጻ ፊትለፊት ደሊና ሞል 3ኛ ፎቅ",
         "In Front of Kality Prison, Sheger Building 1nd floor Branch": "ቃሊቲ ማረሚያ ፊት ለፊት፣ ሸገር ሕንጻ 2ኛ ፎቅ",
        "Kazanchis In Front of Yordanos Hotel, Enat Building, 3rd Floor": "ካዛንቺስ ዮርዳኖስ ሆቴል ፊት ለፊት እናት ሕንጻ፣ 3ኛ ፎቅ",
        "Debre Zeit Road Near Agona Cinema, Balkar Building":"ጠመንጃ ያዥ ፤ ግሎባል ሆቴል 1ኛ ፎቅ",
        "Around Lafto View Gesem Building 3rd Floor":"ላፍቶ ቪው አካባቢ ገሰም ሕንጻ 3ኛ ፎቅ",
        "Near Mexico Square In front of Philips Building, “Chelelek Aslam Tower” 2nd Floor":"ሜክሲኮ አደባባይ ዝቅ ብሎ፣ ፊሊፕስ ሕንጻ ፊት ለፊት፣ አልሳም  ጨለለቅ ታወር 2ኛ ፎቅ",
        "Megenagna Derartu tulu Building": "መገናኛ ደራርቱ ቱሉ ሕንጻ 3ኛ ፎቅ",
        "Qera near to sante clinic, HD building 2nd floor": "ቄራ  ሳንቴ ክሊኒክ አጠገብ፣ HD ሕንጻ 2ኛ ፎቅ",
        "Branch four sidist kilo around Egypt embassy international leadership institute 2nd floor": "ስድስት ኪሎ ግብጽ  ኤምባሲ አካባቢ ስራ አመራር ህንጻ 2ኛ ፎቅ",
        "Summit Safari, just before the traffic light, next to the British School building": "ሳሚት ሳፋሪ፣ ትራፊክ መብራቱ ጋር ሳይደርሱ  ብሪቲሽ ትምህርት ቤት አጠገብ ",
        "In front of Saba Building Delina Mall 3rd Floor" : "ሳባ ሕንጻ ፊት ለፊት ደሊና ሞል 3ኛ ፎቅ",
        "Temneja Yaz, Global Hotel, First Hotel Branch" : "ጠመንጃ ያዥ ፤ ግሎባል ሆቴል 1ኛ ፎቅ",
        "Megenagna VIP": "መገናኛ VIP",
          "moreThanThreeDocumentsWarning": "ከ 3 በላይ ሰነዶች ካሉዎት፣ እባክዎን ሌላ ቀጠሮ ይያዙ።",
            "moreThanTwoDocumentsWarning": "ከ 2 በላይ ሰነዶች ካሉዎት፣ እባክዎን ሌላ ቀጠሮ ይያዙ።",
        "All services available except PLC meeting minutes": "ከ ድርጅት ቃለ ግባኤ በስተቀር ሁሉም ይሰጣል",
        "All Plc Service Provided": "ሁሉም የደርጂት አገልግሎት ይሰጣል",
        "maxRescheduleLimitReached": "ተለዋጭ ቀጠሮ ምዝገባ አልቋል ",
        "rescheduleSuccessful": "ተለዋጭ ቀጠሮው ተሳክቷል",
        "reschedulingSummary": "ተለዋጭ ቀጠሮ ማጠቃለያ",
        "Ayat Square – the building where Lomiad Supermarket is located, 3rd floor.”": "አያት አደባባይ – የሎሚያድ ሱፐርማርኬት ያለበት ሕንጻ፣ 3ኛ ፎቅ",
        "free": "በነፃ",
        "confirmReschedule": "የተለዋጭ ቀጠሮ መዝገባ አረጋግጥ",
        "rescheduleAppointment": "ተለዋጭ ቀጠሮ መዝገብ",
        "Mon": "ሰኞ",
        "Tue": "ማክሰኞ",
        "Wed": "ረቡዕ",
        "Thu": "ሐሙስ",
        "Fri": "አርብ",
        "Sat": "ቅዳሜ",
        "Sun": "እሁድ",
        Available: "በስራ ላይ",
        "Coming Soon": "በቅርብ ቀን",
        "Except Partnership Association, All Plc Service Provided": "ከሽርክና ማህበር በስተቀር ሁሉም የድርጅት አገልግሎቶች ይሰጣሉ",
        "Please check another time or date": "እባክዎ ሌላ ጊዜ ወይም ቀን ይመልከቱ",
        "priceSummary": "የክፍያ ማጠቃለያ",
        "totalServiceCharge": "ጠቅላላ የአገልግሎት ክፍያ",
        "Telebirr" : "ቴሌብር",
        "Telebirr-Qetero" : "ቴሌብር-ቀጠሮ",
        "bookingSummary": "የቀጠሮ ማጠቃለያ",
        "Exit" : "ውጣ",
        "Please review our terms before proceeding.": "እባክዎ ከመቀጠል በፊት ሕጎቻችንን ያስተውሉ",
        "I Understand" : "ተረድቻለዉ",
        "Translation" : "ትርጉም",
        "Foreign Affairs" : "ዉጭ ጉዳይ",
        "Correction":"ማረሚያ",
        "Oath and Affirmation":"ቃለ መሃላ እና ማረጋገጫ",
        "Back to home" : "ወደ ዋና ገጽ",
        "Use the QR code to manage your Qetero and to get your booking detail.": " ",
         "whoIsAppointmentfor" : " ለማን ነው ቀጠሮ የተያዘው?",
           "pleaseSelectBookingFor" : "እባክዎ ለማን እንደሚያዝ ይምረጡ",
           "bookForMyselfDesc" : "ለራሴ እየያዝኩ ነው",
           "bookForOtherDesc" : "ለሌላ ሰው እየያዝኩ ነው",
           "selectNumberOfDocuments": "የሰነዶች ብዛት ይምረጡ",
           "appointmentCreatedRedirecting" : "ቀጠሮዎ ተፈጥሯል እና ወደ ክፍያ እየተመራ ነው...",
           "nameValidationFailed": "ያስገቡት ስም በዚህ ስልክ ቁጥር ከተመዘገበው ተጠቃሚ ጋር አይመሳሰልም።"






    },

},
  },
  lng: getInitialLanguage(), // use safe function instead of direct localStorage
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;